export const CHARTSMART_PLAN = {
  starter: "starter",
  pro: "pro",
  unlimited: "unlimited",
  payg: "payg",
};

export const CHARTSMART_PLAN_WEIGHTS = {
  [CHARTSMART_PLAN.starter]: 1,
  [CHARTSMART_PLAN.pro]: 2,
  [CHARTSMART_PLAN.unlimited]: 3,
};
